// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/wir-oeffnen-die-tueren-zu-unserer-produktion/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const wirOeffnenDieTuerenZuUnsererProduktionDE: PageEntry = {
  id: "post.wir-oeffnen-die-tueren-zu-unserer-produktion",
  locale: "de",
  slug: "wir-oeffnen-die-tueren-zu-unserer-produktion",
  seo: {
    title: "Wir öffnen die Türen zu unserer Produktion | Dietz GmbH",
    description: "Wir öffnen die Türen zu unserer Produktion",
  },
  type: "post",
  h1: "Wir öffnen die Türen zu unserer Produktion",
  blocks: [
    { kind: "heading", level: 2, text: "Wir öffnen die Türen zu unserer Produktion" },
    { kind: "paragraph", text: "Die Feder im Kugelschreiber kennt jeder. Doch wenige wissen, wie man diese Teile fertigt und welche Technologie dahinter steckt." },
    { kind: "paragraph", text: "Wir öffnen die Türen zu unserer Produktion am 03. Oktober 2014 von 13:00 – 16:00 Uhr." },
    { kind: "paragraph", text: "Normalerweise kann man die Produktion nicht sehen. Wir zeigen euch aber, wie man vom Draht oder Bandmaterial zur Herstellung von Federn und Stanz-Biegeteilen kommt – mit allen Zwischenschritten!" },
    { kind: "paragraph", text: "Also schnell anmelden und dazulernen …" },
    { kind: "paragraph", text: "Wir freuen uns auf EUCH!!!" }
  ],
};
